import type { Prototype } from "../prototype-types";

const PROJECT = "Ads Design Sprint Apr. '22";

export const brianSolomonPrototypes: Prototype[] = [
  {
    id: "search-ads-grid",
    name: "Search Ads Grid",
    path: "/bri/search-ads-grid",
    description:
      "Bold 'Brand Moment' ad format that breaks the search grid with full-width sponsored brand takeovers, plus inline sponsored product tiles.",
    owner: "Brian",
    createdAt: "2026-04-17",
    lastUpdated: "2026-04-17",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/eb9844f9ad15d18116594397bcdac57e1c7285f4eac79dbc2cf2f1dcb007a333.png",
    creationTool: "claude-code",
    project: PROJECT,
  },
  {
    id: "haunted-shelf-ads",
    name: "Haunted Shelf Ads",
    path: "/bri/haunted-shelf-ads",
    description:
      "Ghost products from advertised brands materialize on a retailer's shelf — semi-transparent, glowing, haunting. Three wild formats: ghost tiles in search, phantom entries in order history, and possessed product tiles that glitch and switch.",
    owner: "Brian",
    createdAt: "2026-04-22",
    lastUpdated: "2026-04-22",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/75c884729e68528c7e411b1c30610d16287b5183ab270fb4d16089139800e1c3.png",
    creationTool: "claude-code",
    project: PROJECT,
  },
  {
    id: "brand-livestream",
    name: "Faire Live — Brand Livestream",
    path: "/bri/brand-livestream",
    description:
      "A live shopping surface where brands broadcast product showcases to retailers in real time — with live pricing, countdown timers, instant ordering, and live chat.",
    owner: "Brian",
    createdAt: "2026-04-22",
    lastUpdated: "2026-04-22",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/9d757b307b581973025310a75eb82e1e12bc925fb11aeb4288df32adf5a8df68.png",
    creationTool: "claude-code",
    project: PROJECT,
  },
  {
    id: "promoted-placement-scatter",
    name: "Promoted Placement — Scattered",
    path: "/bri/promoted-placement-scatter",
    description:
      "Explores scattered promoted product placement across the search grid with varied label synonyms (Sponsored, Ad, Featured) instead of fixed column positions.",
    owner: "Brian",
    createdAt: "2026-04-22",
    lastUpdated: "2026-04-22",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/0d177922474cb078c65e4655d78d554aaab10120d79e84f43471750221065be3.png",
    project: PROJECT,
  },
  {
    id: "promoted-brand-banner",
    name: "Promoted Brand Banner — Small",
    path: "/bri/promoted-brand-banner",
    description:
      "A compact promoted brand banner at the top of the search grid, featuring product thumbnails and star ratings while keeping the grid unchanged below.",
    owner: "Brian",
    createdAt: "2026-04-22",
    lastUpdated: "2026-04-22",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/751c5b158d266647166dabc0c8eeb2203c84a7032621231faca489a73efdfc71.png",
    project: PROJECT,
  },
  {
    id: "search-ads-experiments",
    name: "Search Grid Ads — Wild Concepts",
    path: "/bri/search-ads-experiments",
    description:
      "6 experimental ad formats for the Search product grid: brand takeover rows, gravity-defying floating tiles, flash auction countdowns, AI sommelier strips, holographic foil tiles, and brand story pods.",
    owner: "Brian",
    createdAt: "2026-04-17",
    lastUpdated: "2026-04-17",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/64d9860705ea645afed8b0c90c91da76cda8e4bc270ff80dad6e69cd97205f14.png",
    creationTool: "claude-code",
    project: PROJECT,
  },
  {
    id: "bri-video-ads-m0-category-compare",
    name: "Video Ads M0 — Category Compare",
    path: "/bri/video-ads-m0-category-compare",
    description:
      "Search-grid Video Ads M0 treatment: 2+2 static vs video for Jewelry, Home Decor, Beauty & Wellness, Paper & Novelty, and Kids & Baby (CTR O/E on each); 5-col category CTR; HVHP vs non-HVHP; Opening vs Reorder; duration Q1–Q5.",
    owner: "Brian Solomon",
    createdAt: "2026-10-02",
    lastUpdated: "2026-10-05",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/f60e2de1a4dfa286b23328cdf781e99aef9e950d1576c9a502b1442c8ce7e065.png",
    creationTool: "cursor",
    project: "Video Ads M0",
  },
  {
    id: "bri-video-only-ad-tiles",
    name: "Video-Only Ad Tiles",
    path: "/bri/video-only-ad-tiles",
    description: "Search results grid where every tile is a video — the top 100 video-backed products by real search impressions over the last 30 days, each playing its own published production video.",
    owner: "Brian Solomon",
    createdAt: "2026-07-17",
    lastUpdated: "2026-07-17",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "https://cdn.prerelease.faire.dev/fastly/7fe93182de632a4db43a1da275289251efdd95b4e1674eaf3a728e2698881161.png",
    creationTool: "claude-code",
  },
  {
    id: "bri-video-only-ad-tiles-ads",
    name: "Video-Only Ad Tiles — Ads Only",
    path: "/bri/video-only-ad-tiles-ads",
    description: "Companion to Video-Only Ad Tiles, scoped to paid impressions — the top 100 video-backed products by paid (is_ads) search impressions over the last 30 days, every tile playing its own published production video.",
    owner: "Brian Solomon",
    createdAt: "2026-07-17",
    lastUpdated: "2026-07-17",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "https://cdn.prerelease.faire.dev/fastly/f60e2de1a4dfa286b23328cdf781e99aef9e950d1576c9a502b1442c8ce7e065.png",
    creationTool: "claude-code",
  },
  {
    id: "bri-video-only-ad-tiles-sampled",
    name: "Video-Only Ad Tiles — Weighted Sample",
    path: "/bri/video-only-ad-tiles-sampled",
    description: "Third take on Video-Only Ad Tiles: 100 video-backed products randomly sampled weighted by paid search impressions over the last 30 days — a realistic mix of heavy hitters and long-tail ads, every tile playing its own production video.",
    owner: "Brian Solomon",
    createdAt: "2026-07-17",
    lastUpdated: "2026-07-17",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "https://cdn.prerelease.faire.dev/fastly/9d70ee5eb8edc046850e917719977267f93f71154dff4e2b527967b437734e3c.png",
    creationTool: "claude-code",
  }
];
